import React from 'react';
import { VIEWBOX } from './iconStyles';

// ##### 25-05-21 Komarov
const Coach = () => (
  <svg
    data-component="Coach"
    color="#102D69"
    width="30"
    height="30"
    aria-hidden="true"
    focusable="false"
    data-prefix="fas"
    data-icon="bus-alt"
    className="svg-inline--fa fa-bus-alt fa-w-16"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox={VIEWBOX.SIZE_512}
  >
    <path
      fill="currentColor"
      d="M488 128h-8V80c0-44.8-99.2-80-224-80S32 35.2 32 80v48h-8c-13.25 0-24 10.74-24 24v80c0 13.25 10.75 24 24 24h8v160c0 17.67 14.33 32 32 32v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h192v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h6.4c16 0 25.6-12.8 25.6-25.6V256h8c13.25 0 24-10.75 24-24v-80c0-13.26-10.75-24-24-24zM160 72c0-4.42 3.58-8 8-8h176c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H168c-4.42 0-8-3.58-8-8V72zm-48 328c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm128-112H128c-17.67 0-32-14.33-32-32v-96c0-17.67 14.33-32 32-32h112v160zm32 0V128h112c17.67 0 32 14.33 32 32v96c0 17.67-14.33 32-32 32H272zm128 112c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    />
  </svg>
);

// ##### 25-05-21 Komarov
export default Coach;
